import type { FC } from 'react';
import type { LineProps } from './index';

export const MediumLine: FC<LineProps> = ({ color }) => {
    return (
        <svg width="88" height="2" viewBox="0 0 88 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 1H88" stroke={color} strokeWidth="2" />
        </svg>
    );
};
